import React from 'react';
import PropTypes from 'prop-types';

import { IS_EDITOR_MODE } from 'config/envVariable';
import { functional, system900 } from 'Mui/styles/color';
import MuiThemeProvider, { promoTheme, promoThemeClient } from 'styles/MuiThemeProvider';

const customColor = '#ff004e';

export default function ProviderTheme({ children, config = {} }) {
    const theme = IS_EDITOR_MODE
        ? promoTheme
        : promoThemeClient({
              primaryColor: functional.color,
              secondaryColor: customColor,
              textColor: system900.color,
              fontFamily: config.fontFamily
          });

    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}

ProviderTheme.propTypes = {
    children: PropTypes.node
};
